import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { ChevronRight, ChevronLeft } from "lucide-react";

const Hackathons = () => {
    return (
        <section className="hackathons-section" style={{ backgroundColor: "#f5f2ff" }}>
            <Container>
                <Row className="align-items-center">
                    <Col lg={6} md={12}>
                        <div className="hackathon-content">
                            <h2 className="title">Real-World Application</h2>
                            <ul className="features-list">
                                <li>
                                    <span className="feature-icon">✓</span>
                                    Prepare for interviews with AI-driven mock sessions, feedback analysis, and personalized improvement plans.
                                </li>
                                <li>
                                    <span className="feature-icon">✓</span>
                                    Benhance your resume with real-time AI suggestions, formatting tips, and industry-specific optimizations.
                                </li>
                                <li>
                                    <span className="feature-icon">✓</span>
                                    Conduct in-depth job market research to identify emerging trends, salary benchmarks, and in-demand skills.
                                </li>
                                <li>
                                    <span className="feature-icon">✓</span>
                                    Connect directly with potential employers through exclusive hiring networks, mentorship programs, and industry events.
                                </li>
                            </ul>
                        </div>
                    </Col>
                    <Col lg={6} md={12}>
                        <div className="hackathon-image">
                            <img
                                src="../../../images/about/real-world.png"
                                alt="Real World Applications"
                                className="img-fluid"
                            />
                        </div>
                    </Col>
                </Row>
            </Container>
        </section>
    );
};

export default Hackathons;